export default {
  // Meta & Header
  siteTitle: 'CSSBuy Spreadsheet 2026 | Guides, Produkte, QC & Versand',
  siteDescription: 'Entdecken Sie das CSSBuy Spreadsheet mit Produktrecherche-Guides, QC-Tipps, Versandinformationen, Vergleichen, Sicherheitsressourcen und praktischen Kauf-Guides.',
  navHome: 'Startseite',
  navShoppingGuide: 'Einkaufs-Guide',
  navSpreadsheet: 'CSSBuy Spreadsheet',
  navReview: 'Review',
  navShipping: 'Versand',
  navGuide: 'Guide',
  navSafety: 'Sicherheit',
  navFAQ: 'FAQ',
  navCategories: 'Kategorien',
  navDropdownCategories: 'Produktkategorien',
  navEnglish: 'English',
  navGerman: 'Deutsch',
  navPortuguese: 'Português',
  navOpen: 'Menü öffnen',
  navClose: 'Menü schließen',

  // Hero Section
  heroH1: 'CSSBuy Spreadsheet: Finden, Vergleichen & Besser Recherchieren',
  heroSubtitle: 'Entdecken Sie das CSSBuy Spreadsheet, um Produkte zu recherchieren, Optionen zu vergleichen und QC, Lagerung, Versand und andere wichtige Punkte vor dem Kauf besser zu verstehen.',
  heroCtaPrimary: 'CSSBuy Spreadsheet erkunden',
  heroCtaSecondary: 'CSSBuy Guide ansehen',
  heroTrust: 'Aktualisiert 2026 · Praktische Guides · QC · Versand · Vergleiche · Sicherheit',

  // What is CSSBuy Spreadsheet
  whatIsH2: 'Was ist das CSSBuy Spreadsheet?',
  whatIsText: 'Das CSSBuy Spreadsheet ist eine organisierte Ressource für Produktrecherche. Erkunden Sie Kategorien, vergleichen Sie Optionen und konsultieren Sie Guides zu QC, Preisen, Lagerung und Versand, um fundiertere Entscheidungen zu treffen.',
  whatIsCta: 'CSSBuy Spreadsheet ansehen',

  // Benefits
  benefitsH2: 'Besser recherchieren vor dem Kauf',
  benefit1Title: 'Organisierte Recherche',
  benefit1Text: 'Finden Sie Kategorien und relevante Informationen an einem Ort.',
  benefit2Title: 'Optionen vergleichen',
  benefit2Text: 'Vergleichen Sie Produkte, Methoden und Alternativen vor der Entscheidung.',
  benefit3Title: 'Praktische Guides',
  benefit3Text: 'Lernen Sie über QC, Warehouse, Versand und Kosten.',
  benefit4Title: 'Mehr Sicherheit',
  benefit4Text: 'Überprüfen Sie wichtige Empfehlungen im Safety Center.',

  // Categories
  categoriesH2: 'Beliebte Kategorien erkunden',
  categoriesCta: 'Alle Kategorien erkunden',
  catShoes: 'Shoes',
  catHoodies: 'Hoodies/Sweaters',
  catTshirts: 'T-Shirts',
  catJackets: 'Jackets',
  catPants: 'Pants/Shorts',
  catHeadwear: 'Headwear',
  catSets: 'Sets',
  catUnderwear: 'Underwear/Underpants',
  catJersey: 'Jersey',
  catAccessories: 'Accessories',
  catBags: 'Bags',
  catBelts: 'Belts',
  catPerfumes: 'Perfumes',
  catOther: 'Other Stuff',

  // How It Works
  howItWorksH2: 'So verwenden Sie das CSSBuy Spreadsheet',
  step1: 'Wählen Sie eine Kategorie',
  step2: 'Produkte recherchieren',
  step3: 'Informationen vergleichen',
  step4: 'QC überprüfen',
  step5: 'Den zugehörigen Guide lesen',
  step6: 'Recherche auf der Hauptseite fortsetzen',
  howItWorksNote: 'Preise, Verfügbarkeit, Richtlinien und Versandoptionen können sich ändern. Bestätigen Sie immer aktuelle Informationen vor dem Kauf.',

  // Review Section
  reviewH2: 'CSSBuy Review: Was Sie wissen müssen',
  reviewText: 'Überprüfen Sie unsere Analyse von Funktionen, QC, Warehouse, Versand, Kosten und wichtigen Punkten für Anfänger.',
  reviewCta: 'CSSBuy Review lesen',

  // Shipping Section
  shippingH2: 'CSSBuy Shipping Cost: Verstehen Sie die Gesamtkosten',
  shippingText: 'Die Versandkosten können je nach Gewicht, Abmessungen, Ziel und gewählter Methode variieren. Sehen Sie unseren Guide, um die Hauptfaktoren zu verstehen, die die Kosten beeinflussen.',
  shippingCta: 'Versand-Guide ansehen',

  // Safety Section
  safetyH2: 'Sicherer recherchieren',
  safetyText: 'Überprüfen Sie URLs, Produktinformationen, QC, Zahlungen und Richtlinien vor jeder Transaktion. Teilen Sie niemals Passwörter oder vertrauliche Informationen.',
  safetyCta: 'Safety Center öffnen',
  safetyCheckUrl: 'URL überprüfen',
  safetyProtectPassword: 'Passwort schützen',
  safetyVerifyPayment: 'Zahlung überprüfen',
  safetyReviewQC: 'QC überprüfen',
  safetyCheckShipping: 'Versand prüfen',
  safetyKeepRecords: 'Aufzeichnungen führen',

  // Final CTA
  finalCtaH2: 'Bereit, Ihre Recherche zu starten?',
  finalCtaText: 'Erkunden Sie das CSSBuy Spreadsheet und finden Sie Guides, Kategorien, Vergleiche und Ressourcen, um Ihre Recherche besser zu organisieren.',
  finalCtaButton: 'CSSBuy Spreadsheet erkunden',

  // Articles Preview
  articlesH2: 'Neueste Artikel & Guides',
  articlesSubtitle: 'Komplette Guides und originelle Artikel über Produktrecherche, QC, Versand und Sicherheit.',
  articlesCta: 'Alle Artikel ansehen',
  article1Title: 'CSSBuy Spreadsheet 2026: Kompletter Guide',
  article1Desc: 'Entdecken Sie, wie Sie das CSSBuy Spreadsheet nutzen, um Produkte organisiert und effizient zu recherchieren.',
  article2Title: 'CSSBuy Versand-Guide: Alles über Versand',
  article2Desc: 'Verstehen Sie Versandmethoden, Kosten, Zeitrahmen und wie Sie die beste Option wählen.',
  article3Title: 'CSSBuy QC Guide: Qualitätsprüfung',
  article3Desc: 'Lernen Sie, QC-Fotos zu analysieren und die Produktqualität vor dem Versand zu überprüfen.',

  // FAQ
  faqH2: 'Häufig gestellte Fragen',
  faq1Q: 'Was ist das CSSBuy Spreadsheet?',
  faq1A: 'Das CSSBuy Spreadsheet ist eine organisierte Ressource, die bei der Produktrecherche, dem Vergleich von Optionen und der Konsultation von Guides zu QC, Preisen, Lagerung und Versand hilft.',
  faq2Q: 'Ist CSSBuy sicher?',
  faq2A: 'Die Sicherheit hängt davon ab, wie Sie den Service nutzen. Folgen Sie unseren Empfehlungen im Safety Center, überprüfen Sie URLs, schützen Sie Ihre Passwörter und überprüfen Sie immer QC vor dem Versand.',
  faq3Q: 'Wie funktioniert der Versand?',
  faq3A: 'Die Versandkosten variieren je nach Gewicht, Abmessungen, Ziel und gewählter Methode. Konsultieren Sie unseren vollständigen Guide, um die Faktoren zu verstehen, die die Gesamtkosten beeinflussen.',
  faq4Q: 'Welche Kategorien sind verfügbar?',
  faq4A: 'Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes und Other Stuff.',

  // Footer
  footerLinks: 'Nützliche Links',
  footerGuides: 'Guides',
  footerCategories: 'Kategorien',
  footerLegal: 'Rechtliches',
  footerAbout: 'Über uns',
  footerContact: 'Kontakt',
  footerDisclaimer: 'Disclaimer',
  footerPrivacy: 'Datenschutzrichtlinie',
  footerTerms: 'Nutzungsbedingungen',
  footerEditorial: 'Redaktionelle Richtlinie',
  footerSpreadsheet: 'CSSBuy Spreadsheet',
  footerReview: 'CSSBuy Review',
  footerShippingGuide: 'Versand-Guide',
  footerQCGuide: 'QC Guide',
  footerCouponGuide: 'Coupon-Guide',
  footerWarehouseGuide: 'Warehouse-Guide',
  footerCopyright: '© 2026 CSSBuy Spreadsheet. Alle Rechte vorbehalten.',
  footerDisclaimerText: 'Diese Website ist eine unabhängige Informationsressource. Sie garantiert keine Produkte, Verkäufer, Preise, Versanddienste, Rückerstattungen oder Dritttransaktionen.',

  // Buttons
  btnMainSite: 'CSSBuy Spreadsheet',
  btnBuyNow: 'Buy It Now',
  btnReadMore: 'Mehr lesen',
  btnExplore: 'Erkunden',
  btnLearnMore: 'Mehr erfahren',

  // Disclaimer
  infoDisclaimer: 'Informationen können sich ändern. Überprüfen Sie aktuelle Details vor der Bestellung.',

  // Table headers
  tableFeature: 'Funktion',
  tableCssbuy: 'CSSBuy',
  tableSuperbuy: 'Superbuy',
  tableSugargoo: 'Sugargoo',
  tableCheck: 'Prüfen',
  tableCompare: 'Vergleichen',

  // Breadcrumbs
  breadcrumbHome: 'Startseite',
  breadcrumbSpreadsheet: 'CSSBuy Spreadsheet',
  breadcrumbReview: 'Review',
  breadcrumbShipping: 'Versand',
  breadcrumbGuide: 'Guide',
  breadcrumbSafety: 'Sicherheit',
  breadcrumbFAQ: 'FAQ',
  breadcrumbCategories: 'Kategorien',
  breadcrumbArticles: 'Artikel',

  // Comparison page
  comparisonH1: 'CSSBuy vs Alternativen: Kompletter Vergleich',
  comparisonIntro: 'Vergleichen Sie CSSBuy mit anderen Einkaufsagenten, um die beste Option für Ihre Bedürfnisse zu finden.',
  comparisonProductResearch: 'Produktrecherche',
  comparisonQC: 'QC',
  comparisonWarehouse: 'Warehouse',
  comparisonShipping: 'Versand',
  comparisonBeginnerFriendly: 'Anfängerfreundlich',
  comparisonNote: 'Informationen können sich ändern. Überprüfen Sie aktuelle Details vor der Bestellung.',

  // Shipping page
  shippingH1: 'CSSBuy Shipping Cost: Kompletter Guide',
  shippingIntro: 'Verstehen Sie alle Faktoren, die CSSBuy-Versandkosten beeinflussen.',
  shippingFactorWeight: 'Paketgewicht',
  shippingFactorDimensions: 'Abmessungen',
  shippingFactorDestination: 'Ziel',
  shippingFactorMethod: 'Versandmethode',
  shippingFactorInsurance: 'Versicherung (optional)',

  // QC Page
  qcH1: 'CSSBuy QC Guide: Qualitätsprüfung',
  qcIntro: 'Lernen Sie, QC-Fotos zu analysieren und die Produktqualität vor dem Versand zu überprüfen.',
  qcStep1: 'Detaillierte Fotos überprüfen',
  qcStep2: 'Mit Verkäuferfotos vergleichen',
  qcStep3: 'Nähte und Materialien prüfen',
  qcStep4: 'Logos und Etiketten überprüfen',
  qcStep5: 'Größen und Maße bestätigen',

  // Safety page
  safetyH1: 'CSSBuy Safety Center: Sicher recherchieren',
  safetyIntro: 'Wichtige Empfehlungen zum Schutz Ihrer Informationen und Transaktionen.',
  safetyUrlVerify: 'URL-Überprüfung',
  safetyUrlVerifyText: 'Überprüfen Sie immer, ob die Website offiziell ist, bevor Sie sich einloggen oder zahlen.',
  safetyPassword: 'Passwortschutz',
  safetyPasswordText: 'Teilen Sie niemals Ihre Passwörter. Verwenden Sie eindeutige Passwörter und Zwei-Faktor-Authentifizierung.',
  safetyPayment: 'Zahlungssicherheit',
  safetyPaymentText: 'Überprüfen Sie sichere Zahlungsmethoden und bestätigen Sie URLs vor Transaktionen.',
  safetyProductInfo: 'Produktinformation',
  safetyProductInfoText: 'Überprüfen Sie Produktdetails, QC und Fotos vor der Bestätigung von Käufen.',
  safetyCustoms: 'Zoll',
  safetyCustomsText: 'Verstehen Sie die Zollvorschriften Ihres Landes vor dem Versand.',
  safetyRecords: 'Transaktionsaufzeichnungen',
  safetyRecordsText: 'Führen Sie Aufzeichnungen über alle Bestellungen, Zahlungen und Sendungen.',

  // Guide page
  guideH1: 'CSSBuy Guide: Kompletter Anfänger-Guide',
  guideIntro: 'Alles, was Sie wissen müssen, um CSSBuy sicher und effizient zu nutzen.',
  guideStep1Title: 'Konto erstellen',
  guideStep1Text: 'Registrieren Sie sich auf der offiziellen Website und richten Sie Ihr Konto mit korrekten Informationen ein.',
  guideStep2Title: 'Produkte recherchieren',
  guideStep2Text: 'Nutzen Sie das CSSBuy Spreadsheet, um Ihre Recherchen zu finden und zu organisieren.',
  guideStep3Title: 'QC überprüfen',
  guideStep3Text: 'Analysieren Sie Qualitätsfotos vor der Versandgenehmigung.',
  guideStep4Title: 'Versand wählen',
  guideStep4Text: 'Wählen Sie die geeignete Versandmethode für Ihr Ziel und Budget.',
  guideStep5Title: 'Bestellung verfolgen',
  guideStep5Text: 'Überwachen Sie den Versandstatus bis zur finalen Lieferung.',

  // Spreadsheet page
  spreadsheetH1: 'CSSBuy Spreadsheet: Komplette Recherche-Ressource',
  spreadsheetIntro: 'Das CSSBuy Spreadsheet ist das zentrale Tool zur Organisation und zum Vergleich Ihrer Produktrecherche.',
  spreadsheetFeature1: 'Organisierte Kategorien',
  spreadsheetFeature2: 'Produktvergleiche',
  spreadsheetFeature3: 'QC-Informationen',
  spreadsheetFeature4: 'Versand-Guides',
  spreadsheetFeature5: 'Sicherheitstipps',
  spreadsheetFeature6: 'Regelmäßige Updates',
  spreadsheetCta: 'Jetzt erkunden',

  // Review page
  reviewH1: 'CSSBuy Review 2026: Komplette Analyse',
  reviewIntro: 'Detaillierte Analyse von Funktionen, Diensten und wichtigen Punkten von CSSBuy.',
  reviewPros: 'Positive Punkte',
  reviewCons: 'Zu beachtende Punkte',
  reviewPro1: 'Organisierte Oberfläche für Recherche',
  reviewPro2: 'Mehrere Versandoptionen',
  reviewPro3: 'QC-System zur Überprüfung',
  reviewPro4: 'Warehouse für Lagerung',
  reviewCon1: 'Versandkosten können stark variieren',
  reviewCon2: 'Zeitrahmen hängen von der gewählten Methode ab',
  reviewCon3: 'Richtlinien können sich ohne Ankündigung ändern',
  reviewCon4: 'Aktuelle Informationen müssen überprüft werden',

  // Article page
  articlePublished: 'Veröffentlicht',
  articleUpdated: 'Aktualisiert',
  articleReadTime: 'Min. Lesezeit',
  articleRelated: 'Verwandte Artikel',
  articleTldr: 'TL;DR',
  articleContents: 'Inhalt',
  articleTips: 'Wichtige Tipps',
  articleSafety: 'Sicherheit',
  articleFaq: 'FAQ',

  // Beginners article
  beginnersH1: 'CSSBuy Spreadsheet für Anfänger: Schritt-für-Schritt-Guide',
  beginnersIntro: 'Dieser komplette Guide zeigt, wie Sie das CSSBuy Spreadsheet nutzen, um Produkte organisiert und effizient zu recherchieren.',
  beginnersSection1H2: 'Was ist das CSSBuy Spreadsheet?',
  beginnersSection1Text: 'Das CSSBuy Spreadsheet ist ein organisiertes Tool, das es Ihnen ermöglicht, Produkte zu recherchieren, Optionen zu vergleichen und Informationen über QC, Versand, Warehouse und Kosten an einem Ort zu konsultieren.',
  beginnersSection2H2: 'So starten Sie',
  beginnersSection2Text: 'Machen Sie sich zunächst mit den verfügbaren Kategorien vertraut. Jede Kategorie enthält organisierte Informationen über relevante Produkte. Nutzen Sie das Kategorien-Menü, um zwischen Shoes, Hoodies, T-Shirts, Jackets und anderen Optionen zu navigieren.',
  beginnersSection3H2: 'So recherchieren Sie Produkte',
  beginnersSection3Text: 'Die Produktrecherche im CSSBuy Spreadsheet ist intuitiv. Wählen Sie eine Kategorie, erkunden Sie verfügbare Optionen und vergleichen Sie verschiedene Produkte, bevor Sie eine Entscheidung treffen. Überprüfen Sie immer aktualisierte Informationen vor dem Kauf.',
  beginnersSection4H2: 'Tipps für Anfänger',
  beginnersSection4Text: 'Überprüfen Sie immer QC, bevor Sie Versand genehmigen. Vergleichen Sie Preise und Versandmethoden. Führen Sie Aufzeichnungen über alle Transaktionen. Nutzen Sie das Safety Center, um wichtige Empfehlungen zu überprüfen.',
  beginnersSection5H2: 'Vergleich: CSSBuy vs Alternativen',
  beginnersSection5Text: 'Vergleichen Sie CSSBuy mit anderen Optionen und berücksichtigen Sie Faktoren wie Produktrecherche, QC, Warehouse, Versand und Benutzerfreundlichkeit für Anfänger.',

  // Common
  readMore: 'Mehr lesen',
  goToMainSite: 'Zur Hauptseite',
  search: 'Suche',
  share: 'Teilen',
  close: 'Schließen',
  loading: 'Laden...',
  error: 'Fehler',
  retry: 'Erneut versuchen',

  // Not Found
  notFoundTitle: 'Seite nicht gefunden',
  notFoundText: 'Die gesuchte Seite existiert nicht.',
  notFoundCta: 'Zurück zur Startseite',
};